<footer class="fuprop-footer">
  <div class="containers">
    <div class="row justify-content-center">
      <!-- Column 1 -->
      <div class="col-lg-3 col-md-6 col-sm-12 mt-3">
        <h3>Fuprop: One stop solution for Real Estate.</h3>
        <div style="font-size: 14px;">
          <i class="fas fa-map-marker-alt"></i>&nbsp;
          FuProp, Flat-103, Plot-478, Krishna colony, Gurgaon, Haryana 122001,
          India
        </div><br>
        <div><a routerLink="/"><i class="fas fa-mobile-alt"></i>
            +91-7838656543</a></div><br>
        <div><a href="mailto:support@fuprop.com"><i class="fa fa-envelope"
              aria-hidden="true"></i> Support@fuprop.com</a></div>
      </div>

      <!-- Column 2 -->
      <div class="col-lg-3 col-md-6 col-sm-12 mt-3">
        <h3>Categories</h3>
        <ul class="fuprop-nav-list">
          <li><a routerLink="/aboutUs"> <i class="fas fa-info-circle"></i> About
              Us</a></li><br>
          <li><a routerLink="/termsandcondition"><i class="fa fa-files-o"></i>
              Term and Conditions</a></li><br>
          <li><a routerLink="/privacyPolicy"><i class="fa fa-user-secret"></i>
              Privacy Policy</a></li><br>
          <li><a routerLink="/FAQ"><i class="fa fa-newspaper-o"></i>
              Faqs</a></li><br>
          <li><a routerLink="/contactUs"><i class="fa fa-phone"></i> Contact
              Us</a></li>
        </ul>
      </div>

      <!-- Column 3 -->
      <div class="col-lg-3 col-md-6 col-sm-12 mt-3">
        <h3>Quick Services</h3>
        <ul class="fuprop-nav-list" style="font-size:14px">
          <li class="checking" (click)="openServiceRequest('Loan')"><i
              class="fas fa-hand-holding-usd"></i> Loan</li><br>
          <li class="checking"
            (click)="openServiceRequest('Property Verification')"><i
              class="fas fa-file-alt"></i> Property Verification</li><br>
          <li class="checking"
            (click)="openServiceRequest('Registery')"><i
              class="fas fa-pen-fancy"></i> Registry</li><br>
          <li class="checking"
            (click)="openServiceRequest('House Cleaning')"><i
              class="fas fa-broom"></i> House Cleaning</li><br>
          <li class="checking"
            (click)="openServiceRequest('Rent Agreement')"><i
              class="fas fa-truck-moving"></i> Rent Agreement</li><br>
          <li class="checking"
            (click)="openServiceRequest('WhiteWash')"><i
              class="fas fa-paint-roller"></i> WhiteWash</li><br>
          <li class="checking"
            (click)="openServiceRequest('Construction & Repair')"><i
              class="fas fa-tools"></i> Construction/Repair</li><br>
          <li class="checking"
            (click)="openServiceRequest('Packer and Mover')"><i
              class="fas fa-tools"></i> Packer and Mover</li>
        </ul>
      </div>

      <!-- Column 4 -->
      <div class="col-lg-3 col-md-6 col-sm-12 mt-3">
        <div class="fuprop-subscribe-container">
          <h3>Subscribe for best deals</h3>
          <div class="fuprop-subscribe-input">
            <input type="email" [(ngModel)]="email"
              placeholder="Enter your email" name="email">
            <button class="setbutton" (click)="submitEmail()">Submit</button>
          </div>
          <div class="fuprop-follow-us">
            <div style="font-weight: 700; margin-top: 9px;">Follow Us:</div>
            <div class="fuprop-social-icons">
              <a href="https://www.facebook.com/people/FuProp/61572741726023/"
                target="_blank" rel="noopener noreferrer">
                <i class="fab fa-facebook-f"></i>
              </a>

              <a href="https://www.linkedin.com/company/fuprop/" target="_blank" rel="noopener noreferrer"><i class="fab fa-linkedin-in"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer"><i class="fab fa-twitter"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer"><i class="fab fa-instagram"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4 fuprop-bottom">
    <div
      class="setting-bottom d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">

      <div class="mb-2 mb-md-0 ffoter">
        ©2025 fuprop.com Team. All Rights Reserved.
      </div>

      <div class="footer-links">
        <a href="/termsandcondition" class="footer-link">Terms of Service</a>
        <a href="/privacyPolicy" class="footer-link">Privacy Policy</a>
        <a href="/aboutUs" class="footer-link">About Us</a>
      </div>

    </div>
  </div>

</footer>
